import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Building } from '@app/shared/models/building.interface';
import { User } from '@app/shared/models/user.interface';
import { NavigationSection } from '@app/shared/services/navigation/navigation-section';
import { Subject, Subscription } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { NavigationService } from '@app/shared/services/navigation/navigation.service';
import { NgClass } from '@angular/common';
import { FloorService } from '@services/floor.service';

@Component({
  selector: 'app-site-menu',
  templateUrl: './site-menu.component.html',
  styleUrls: ['./site-menu.component.scss'],
  imports: [NgClass]
})
export class SiteMenuComponent implements OnInit, OnDestroy {
  @Input() menuItems: NavigationSection[];
  @Input() user: User;
  @Input() building: Building;
  private readonly navigate$ = new Subject<NavigationSection>();

  private navigationSubscription: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly floorService: FloorService,
    private readonly navigationService: NavigationService
  ) {}

  navigateTo(section: NavigationSection): void {
    this.navigate$.next(section);
  }

  ngOnInit(): void {
    this.navigationSubscription = this.navigate$
      .pipe(withLatestFrom(this.route.params))
      .subscribe(([section, parameters]) => {
        const { buildingId } = parameters;
        let { floorId } = parameters;
        if (!floorId && this.isFloorAvailableInBuilding(this.floorService.currentFloorIdValue, this.building)) {
          floorId = this.floorService.currentFloorIdValue;
        }
        this.navigationService.navigateToSection(section, buildingId, floorId);
      });
  }

  ngOnDestroy(): void {
    this.navigationSubscription.unsubscribe();
  }

  isAuthorizedForMenuItemWhenBuildingHasFloors(section: NavigationSection): boolean {
    return (
      section.info.IsAuthorized(this.user, this.building.id) &&
      this.building.floors.length > 0 &&
      (section.info.Id !== 'nms' || this.building.enhancedSecurity === true)
    );
  }

  private isFloorAvailableInBuilding(floorId: number, building: Building): boolean {
    return building.floors.findIndex((f) => f.id === floorId) !== -1;
  }
}
